module.exports = __webpack_public_path__ + "static/media/Version.1c3eeeb5.txt";


//////////////////
// WEBPACK FOOTER
// ./src/Version.txt
// module id = 126
// module chunks = 1